import { useState, useEffect } from 'react';
import { Sector } from '../services/models/sector';
import { SubUser, isRoivUser } from '../services/models/sub_user';
import { Administrator } from '../services/models/administrator';
import { useFetchSectors } from './useQuery/useFetchSectors';

function isAdmin(obj: any): obj is Administrator {
    return obj && obj.role === undefined;
}

/**
 * Хук для управления секторами в форме 30
 */
export const useForm30Sectors = (user: Administrator | SubUser | null) => {
    const userIsAdmin = isAdmin(user);
    const userIsRoiv = !userIsAdmin && user ? isRoivUser(user as SubUser) : false;

    const [selectedSectorId, setSelectedSectorId] = useState<string | null>(null);

    // Получаем список секторов
    const { sectorsData, sectorsIsLoading } = useFetchSectors();

    // Устанавливаем сектор по умолчанию
    useEffect(() => {
        if (sectorsIsLoading || !sectorsData) return;

        // Для администратора выбираем первый сектор
        if (userIsAdmin && sectorsData.length > 0 && !selectedSectorId) {
            setSelectedSectorId(sectorsData[0].id);
        }

        // Для ROIV пользователя выбираем его сектор
        if (userIsRoiv && user && (user as SubUser).sectors && (user as SubUser).sectors.length > 0) {
            const userSectorId = (user as SubUser).sectors[0];
            setSelectedSectorId(userSectorId);
        }
    }, [sectorsData, sectorsIsLoading, userIsAdmin, userIsRoiv, user, selectedSectorId]);

    return {
        sectors: sectorsData || [],
        sectorsIsLoading,
        selectedSectorId,
        setSelectedSectorId,
        userIsAdmin,
        userIsRoiv,
    };
};
